import { PopoverProps, Popover } from '@mantine/core';
import { ReactNode } from 'react';
import '../../../styles/components/hover-card.css'

interface Props extends PopoverProps {
    targetComponent: ReactNode; // Custom content which will be the target for the HoverCard (such as an icon)
    children: ReactNode; // custom content for the hovercard
}

export default function CustomPopover({
    targetComponent,
    children,
    width = '580px',
    withArrow = true,
    withinPortal = true,
    position = 'right',
    arrowSize = 16,
    arrowOffset = 0,
    shadow = 'md',
    classNames,
    ...props
}: Props) {
    return (
        <Popover
            width={width}
            withArrow={withArrow}
            withinPortal={withinPortal}
            position={position}
            arrowSize={arrowSize}
            arrowOffset={arrowOffset}
            shadow={shadow}
            classNames={classNames ?? {
                dropdown: 'popover-body',
            }}
            {...props}
        >

            <Popover.Target>
                <div className='hover-card-target'>
                    {targetComponent}
                </div>
            </Popover.Target>

            <Popover.Dropdown>
                {children}
            </Popover.Dropdown>
        </Popover >
    );
}